import { memo } from "react";
import { PlayIcon } from "@/icons";
import styles from "../PresentationView.module.scss";

type PresentationHeaderViewProps = {
    title: string;
    onTitleClick: (e: React.MouseEvent<HTMLParagraphElement>) => void;
    onPlay: () => void;
    disablePlay: boolean;
};

export const PresentationHeaderView = memo(
    ({ title, onTitleClick, onPlay, disablePlay }: PresentationHeaderViewProps) => {
        return (
            <>
                <p onClick={onTitleClick}>{title}</p>
                <button
                    className={styles.viewHeaderIcon}
                    type="button"
                    onClick={onPlay}
                    disabled={disablePlay}
                >
                    <PlayIcon />
                </button>
            </>
        );
    },
);
